
<template>
  <div>
    <dialog-edit-movement></dialog-edit-movement>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogEditMovement from '../../components/movements/DialogEditMovement.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'ShowMovementPage',
  //mixins: [ validations ],
  components: {
    DialogEditMovement
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>